import {
  Box,
  styled,
  TextField as TextFieldStyle,
  TableContainer as TableContainerStyles,
  TableHead as TableHeader,
  Button,
  css,
} from '@mui/material';

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }

  .btn-back {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 22px 6px 16px;
    gap: 8px;
    width: 125px;
    height: 48px;
    border: 1px solid #212121;
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
    color: #212121;
  }

  .text-add-admin {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  name-admin {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const Title = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const SectionDetails = styled(Box)`
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 20px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .adm {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .btn-add-companie {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    border-radius: 4px;
    width: 202px;
    height: 40px;
  }
`;

export const Typography = styled(Box)``;

export const Div = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .title-details {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    // color: #000000;
  }
  .btn-edit {
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 12px;
    gap: 8px;
    width: 202px;
    height: 40px;
  }

  .id {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #323232;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: 10px;
  }

  .btn-adm {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 12px;
    gap: 8px;
    border-radius: 4px;
    width: 202px;
    height: 40px;
  }

  .data {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #323232;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: 10px;
  }

  #alert-dialog-title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.15px;
    color: #000000;
  }

  #alert-dialog-description {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: rgba(0, 0, 0, 0.54);
  }
  #dialog-main {
    padding: 20px;
  }
`;

export const Member = styled(Box)``;

export const Companies = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 340px;
  height: 129px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;
`;

export const Logo = styled(Box)``;

export const InfoCompanies = styled(Box)`
  display: flex;
  flex-direction: column;

  .status-ativo {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 10px;
    gap: 3px;
    width: 52px;
    height: 22px;
    background: #4caf50;
    border-radius: 17px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
  }

  .status-desativado {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 10px;
    gap: 3px;
    width: 89px;
    height: 22px;
    background: #e31b0c;
    border-radius: 17px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
  }
  .companyName {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .companyLength {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #9e9e9e;
  }
`;

export const SectionCompanies = styled(Box)`
  display: grid;
  gap: 20px;
  grid-template-areas: 'company company company company';

  @media (max-width: 1835px) {
    grid-template-areas: 'company company company';
  }

  @media (max-width: 1415px) {
    grid-template-areas: 'company company';
    display: grid;
    justify-content: space-evenly;
  }
`;

export const Page = styled(Box)`
  .btn-save {
    width: 156px;
    height: 42px;
    position: fixed;
    right: 20px;
    bottom: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
  }

  .title-admin {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }

  .btn-add-usuario {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 22px;
    gap: 8px;
    width: 100%;
    height: 42px;
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
  }
`;

export const SectionInputs = styled(Box)`
  .add-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    width: 440px;
    height: 60px;
    border: 1px dashed #bdbdbd;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const HeaderEdit = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0px 16px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 20px;
  .edit-dados {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 30%;
  }
  .add-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 24%;
  }
  .change-adm {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-left: 17%;
  }
`;

export const CardNewAdmin = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0px;
  width: 100%;
  height: 62px;
  border-top: 1px solid #e0e0e0;
`;

export const Subtitle = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.grey.A700};
  margin-bottom: 20px;
`;
